import { requestJson } from "@/lib/api";
import type { DeliveredOrder } from "@/lib/driverApi";

export interface DriverOption {
  id: string;
  name: string;
  email: string;
}

export interface AdminDeliveryRoute {
  orderId: string;
  clientName: string;
  deliveryWindow?: string | null;
  deliveryDate?: string | null;
  routeStartedAt?: string | null;
  driverId?: string | null;
  driverName?: string | null;
  notes?: string | null;
}

export async function fetchDriverOptions(): Promise<DriverOption[]> {
  return requestJson<DriverOption[]>("/api/v1/admin/drivers");
}

export async function fetchAdminRoutes(date?: string, driverId?: string): Promise<AdminDeliveryRoute[]> {
  const params = new URLSearchParams();
  if (date) params.set("date", date);
  if (driverId) params.set("driverId", driverId);
  const qs = params.toString() ? `?${params}` : "";
  return requestJson<AdminDeliveryRoute[]>(`/api/v1/admin/deliveries/routes${qs}`);
}

export async function fetchAdminDelivered(date?: string, driverId?: string): Promise<DeliveredOrder[]> {
  const params = new URLSearchParams();
  if (date) params.set("date", date);
  if (driverId) params.set("driverId", driverId);
  const qs = params.toString() ? `?${params}` : "";
  return requestJson<DeliveredOrder[]>(`/api/v1/admin/deliveries/delivered${qs}`);
}
